import { render, staticRenderFns } from "./TrainingFilesPanel.vue?vue&type=template&id=2b527de4"
import script from "./TrainingFilesPanel.vue?vue&type=script&lang=js"
export * from "./TrainingFilesPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports